/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetEmployeesPositionsForCreateOwnerDocument = gql`
    query GetEmployeesPositionsForCreateOwner($companyId: Int!) {
  user {
    company(id: $companyId) {
      employeePositions {
        employeePositions {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesPositionsForCreateOwnerQuery__
 *
 * To run a query within a React component, call `useGetEmployeesPositionsForCreateOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesPositionsForCreateOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesPositionsForCreateOwnerQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmployeesPositionsForCreateOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables> & ({ variables: GetEmployeesPositionsForCreateOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables>(GetEmployeesPositionsForCreateOwnerDocument, options);
      }
export function useGetEmployeesPositionsForCreateOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables>(GetEmployeesPositionsForCreateOwnerDocument, options);
        }
export function useGetEmployeesPositionsForCreateOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables>(GetEmployeesPositionsForCreateOwnerDocument, options);
        }
export type GetEmployeesPositionsForCreateOwnerQueryHookResult = ReturnType<typeof useGetEmployeesPositionsForCreateOwnerQuery>;
export type GetEmployeesPositionsForCreateOwnerLazyQueryHookResult = ReturnType<typeof useGetEmployeesPositionsForCreateOwnerLazyQuery>;
export type GetEmployeesPositionsForCreateOwnerSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesPositionsForCreateOwnerSuspenseQuery>;
export type GetEmployeesPositionsForCreateOwnerQueryResult = Apollo.QueryResult<GetEmployeesPositionsForCreateOwnerQuery, GetEmployeesPositionsForCreateOwnerQueryVariables>;
export const GetCompanyIdForCreateOwnerDocument = gql`
    query GetCompanyIdForCreateOwner($companyId: Int!) {
  user {
    id
    company(id: $companyId) {
      id
      name
      ownerPosition {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCompanyIdForCreateOwnerQuery__
 *
 * To run a query within a React component, call `useGetCompanyIdForCreateOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIdForCreateOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIdForCreateOwnerQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyIdForCreateOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables> & ({ variables: GetCompanyIdForCreateOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables>(GetCompanyIdForCreateOwnerDocument, options);
      }
export function useGetCompanyIdForCreateOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables>(GetCompanyIdForCreateOwnerDocument, options);
        }
export function useGetCompanyIdForCreateOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables>(GetCompanyIdForCreateOwnerDocument, options);
        }
export type GetCompanyIdForCreateOwnerQueryHookResult = ReturnType<typeof useGetCompanyIdForCreateOwnerQuery>;
export type GetCompanyIdForCreateOwnerLazyQueryHookResult = ReturnType<typeof useGetCompanyIdForCreateOwnerLazyQuery>;
export type GetCompanyIdForCreateOwnerSuspenseQueryHookResult = ReturnType<typeof useGetCompanyIdForCreateOwnerSuspenseQuery>;
export type GetCompanyIdForCreateOwnerQueryResult = Apollo.QueryResult<GetCompanyIdForCreateOwnerQuery, GetCompanyIdForCreateOwnerQueryVariables>;
export type GetEmployeesPositionsForCreateOwnerQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetEmployeesPositionsForCreateOwnerQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', employeePositions?: { __typename?: 'EmployeePositionPaginated', employeePositions?: Array<{ __typename?: 'EmployeePositionProxy', id: number, name: string }> | null } | null } | null } | null };

export type GetCompanyIdForCreateOwnerQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyIdForCreateOwnerQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, name: string, ownerPosition?: { __typename?: 'EmployeePositionProxy', id: number, name: string } | null } | null } | null };
